import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotificationComponent } from './notification-component/notification.component';
import { NotificationDialogComponent } from './notification-dialog/notification-dialog.component';
import { DialogNotificationHandler } from "./notification-dialog/dialog-notification-handler";
import { NotificationHandler } from "./notification-handler";
import { NotificationService } from "./notification.service";
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { TranslocoModule } from '@jsverse/transloco';

@NgModule({
  declarations: [NotificationComponent, NotificationDialogComponent],
  imports: [CommonModule, MatDialogModule, TranslocoModule, MatButtonModule],
  exports: [NotificationComponent],
  providers: [
    NotificationService,
    { provide: NotificationHandler, useClass: DialogNotificationHandler }
  ]
})
export class NotificationModule {}
